module.exports = __webpack_public_path__ + "static/rounded-img1-0e7fb7b417b0d58bdaf35c8d2045f372.png";